import { render, staticRenderFns } from "./ModalInsufficientCreditBuatKonten.vue?vue&type=template&id=95a54de8&scoped=true&"
import script from "./ModalInsufficientCreditBuatKonten.vue?vue&type=script&lang=js&"
export * from "./ModalInsufficientCreditBuatKonten.vue?vue&type=script&lang=js&"
import style0 from "./ModalInsufficientCreditBuatKonten.vue?vue&type=style&index=0&id=95a54de8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95a54de8",
  null
  
)

export default component.exports